var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8228"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33129",
    d: "M3.375 9A5.625 5.625 0 1 1 9 14.625 5.623 5.623 0 0 1 3.375 9zM18 9a9 9 0 1 1-9-9 9 9 0 0 1 9 9zm-9 6.75A6.75 6.75 0 1 0 2.25 9 6.752 6.752 0 0 0 9 15.75z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33130",
    d: "M34.092 47.736a.181.181 0 0 1-.128-.051.171.171 0 0 1-.055-.131v-4.738a.172.172 0 0 1 .055-.131.182.182 0 0 1 .128-.051h.787a.242.242 0 0 1 .179.062.344.344 0 0 1 .076.1l1.283 2.3 1.283-2.3a.73.73 0 0 1 .076-.1.227.227 0 0 1 .179-.062h.78a.191.191 0 0 1 .135.051.172.172 0 0 1 .055.131v4.738a.171.171 0 0 1-.055.131.19.19 0 0 1-.135.051h-.867a.19.19 0 0 1-.135-.051.171.171 0 0 1-.055-.131v-2.733l-.824 1.523a.333.333 0 0 1-.087.117.235.235 0 0 1-.16.051h-.379a.234.234 0 0 1-.16-.051.428.428 0 0 1-.095-.117l-.824-1.523v2.733a.175.175 0 0 1-.182.182z",
    transform: "translate(-27.418 -36.185)",
    style: {
      fill: "#47434d"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/pointsIcon.19249269d05b702317f6b173f44d3a41.svg";
export { ForwardRef as ReactComponent };